// extracted by mini-css-extract-plugin
export default {"title":"BookingLineTitle_title__73QOG"};